module.exports = __webpack_public_path__ + "static/media/header-logo.28dfad8c.svg";